import { render, staticRenderFns } from "./ProtectedDialog.vue?vue&type=template&id=49a3db53"
import script from "./ProtectedDialog.vue?vue&type=script&lang=js"
export * from "./ProtectedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports